import React, { useContext} from 'react';
import {  Table} from 'semantic-ui-react';
import { observer } from 'mobx-react-lite';
import BdodJobsStore from '../../../app/stores/bdodjobsStore';


const EmployeeBdodJobsList: React.FC = () => {
  const bdodjobsStore = useContext(BdodJobsStore);
  const {bdodjobsByDate} = bdodjobsStore;
  var totalAmount = 0;
  return (

      <Table compact  size='small' unstackable>
    <Table.Header>
      <Table.Row>
      <Table.HeaderCell>Work Number</Table.HeaderCell>
          <Table.HeaderCell>Location</Table.HeaderCell>
          <Table.HeaderCell>Date</Table.HeaderCell>
            <Table.HeaderCell>Status</Table.HeaderCell>
            <Table.HeaderCell>Payment</Table.HeaderCell>
            <Table.HeaderCell>Amount($)</Table.HeaderCell>
            <Table.HeaderCell>Remark</Table.HeaderCell>
      </Table.Row>
    </Table.Header>

    <Table.Body>
    {bdodjobsByDate.map(bdodjob => {
    totalAmount = totalAmount + bdodjob.amount;
    return (
    <Table.Row key={bdodjob.id}> 
        <Table.Cell>{bdodjob.workNumber}</Table.Cell> 
        <Table.Cell>{bdodjob.location}</Table.Cell> 
        <Table.Cell>
          {bdodjob.date.substr(8,2) + '/' +
         bdodjob.date.substr(5,2) + '/' + bdodjob.date.substr(0,4)}
        </Table.Cell>
     <Table.Cell>{bdodjob.status}</Table.Cell> 
     <Table.Cell>{bdodjob.payment}</Table.Cell> 
     <Table.Cell>{bdodjob.amount}</Table.Cell> 
     <Table.Cell>{bdodjob.remark}</Table.Cell> 
      
      </Table.Row> 
    )})}
    </Table.Body>
    <Table.Footer>
        <Table.Row>
          <Table.HeaderCell>Total</Table.HeaderCell>
          <Table.HeaderCell />
          <Table.HeaderCell />
          <Table.HeaderCell />         
          <Table.HeaderCell />
          <Table.HeaderCell>$ {totalAmount.toFixed(2)}</Table.HeaderCell>
          <Table.HeaderCell />
          <Table.HeaderCell />
        </Table.Row>
      </Table.Footer>
  </Table>

  );
};

export default observer(EmployeeBdodJobsList);
